module.exports = __webpack_public_path__ + "fonts/GT-Eesti-Display-Regular.9293604.ttf";